import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core'
import { CommonModule } from '@angular/common'
import { IonicModule } from '@ionic/angular'

@Component({
  selector: 'app-loading',
  standalone: true,
  imports: [CommonModule, IonicModule],
  templateUrl: './loading.component.html',
  styleUrls: ['./loading.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LoadingComponent implements OnInit {
  @Input() message: string
  @Input() spinnerType: string
  @Input() cssClass: string
  @Input() showBackdrop: boolean = true

  constructor() {}

  ngOnInit() {}
}
